const imgHandler = {
	data: function () {
		return {
			imgSrcs: [],
		}
	},
	methods: {
		getImgSrc(imgArray, index, srcFiles){
			if(!imgArray || !index || !srcFiles){
				return;
			}

			for(let $i=0; $i<imgArray.length; $i++){
				let matchingImg = srcFiles.find(file => file.filename === imgArray[$i][index][0]);
				if(matchingImg){
					this.imgSrcs.push(matchingImg);
				}
			}
		}
	}
}

export default imgHandler